// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import ArrayUtils from '../../utils/ArrayUtils';

import MenuPartItem from './MenuPartItem';
import MenuPartItemType from './MenuPartItemType';

import { getLocalizedData } from '../../utils/CatalogUtils'

export default class MenuPartCategory extends ApiObject {
  static ROOT_CATEGORY_ID: string = 'root';

  static ROOT_NAME: string = 'root';

  id: string;

  name: string;

  localizedNames: Array<> = [];

  picture: string;

  items: Array<MenuPartItem> = [];

  set name(name) {
    this._name = name
  }

  get name() {
    return getLocalizedData(this.localizedNames) || this._name || ''
  }

  postJsonAssignation(data: Object) {
    this.items = [];
    _.each(data.items, (partItemData: Object) => {
      const item: MenuPartItem = new MenuPartItem();
      item.fromJson(partItemData);
      this.items.push(item);
    });
  }

  isRootCategory() {
    return this.id === MenuPartCategory.ROOT_CATEGORY_ID;
  }

  addProduct(product) {
    this.items.push(MenuPartItem.fromProduct(product));
  }

  removeProductWithId(id) {
    this.items = ArrayUtils.removeObject(
      this.items,
      (item: MenuPartItem) => item.id === id && item.isProduct()
    );
  }

  addCategory(category) {
    this.items.push(MenuPartItem.fromCategory(category));
  }

  removeCategoryWithId(id) {
    this.items = ArrayUtils.removeObject(
      this.items,
      (item: MenuPartItem) => item.id === id && item.isCategory()
    );
  }

  getItemsWithoutEmptyCategories(menuPart) {
    return this.items.filter(item => item.type === MenuPartItemType.CATEGORY
      ? menuPart.getCategoryWithId(item.id).getItemsWithoutEmptyCategories(menuPart).length
      : true
    )
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/MenuPartCategory.js